import { API } from "aws-amplify";

export const GET_PROGRAM_MANAGERS = "GET_PROGRAM_MANAGERS";
export const LOADING_PROGRAM_MANAGERS = "LOADING_PROGRAM_MANAGERS";

export function getProgramManagers(programManagers = {}) {
  return { type: GET_PROGRAM_MANAGERS, programManagers };
}

export function loadingProgramManagers() {
  return { type: LOADING_PROGRAM_MANAGERS };
}

export function startGetProgramManagers(permission_code = "") {
  return (dispatch) => {
    dispatch(loadingProgramManagers());
    const init = {
      queryStringParameters: {
        start: 0,
        size: 1000
      },
      headers: { 'permission-code': permission_code }
    };
    API.get("users", "/programManagers/", init)
      .then(programManagers => {
        dispatch(getProgramManagers(programManagers));
      })
      .catch(error => {
        console.error("ERROR fetching program managers", error);
        dispatch(getProgramManagers([]));
      });
  };
}
